import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RolesHelper {

  public hasAdminRoles(roles: string): boolean {
    const rolesArray = typeof roles === 'string' && roles.split('|') || '';

    return rolesArray.includes('admin') || rolesArray.includes('adminview');
  }

  public hasManagerRoles(roles: string): boolean {
    const rolesArray = typeof roles === 'string' && roles.split('|') || '';

    return rolesArray.includes('manager');
  }

  public hasAdminViewRoles(roles: string): boolean {
    const rolesArray = typeof roles === 'string' && roles.split('|') || '';

    return rolesArray.includes('adminview');
  }
}
